export enum Urls {
  Home = '/',

  Projects = '/projects/',
  Articles = '/articles/',
  ArticlePage = '/articles/:slug/',
  Error = '*',
}
